import getSavedPaymentMethods_MOCK from "./getSavedPaymentMethods_MOCK.js";
import createUpdateSavedPaymentMethodResponse from "./createUpdateSavedPaymentMethodResponse_MOCK";
import deleteSavedPaymentMethodResponse from "./deleteSavedPaymentMethodResponse.js";
import createSavedPaymentMethodResponse from "./createSavedPaymentMethodResponse.js";

const useMockData = false;

// 🚫👇🚫 Don't change this 🚫👇🚫
const _useMockData_PROTECTED =
  process.env.NODE_ENV === "development" ? useMockData : false;
// 🚫👆🚫 Don't change this 🚫👆🚫

const shouldMock = _useMockData_PROTECTED;
const getSavedPaymentMethodsMockResponse = getSavedPaymentMethods_MOCK;

export {
  shouldMock,
  getSavedPaymentMethodsMockResponse,
  createUpdateSavedPaymentMethodResponse,
  deleteSavedPaymentMethodResponse,
  createSavedPaymentMethodResponse,
};
